import React, {useEffect, VoidFunctionComponent} from "react";
import {useDispatch, useSelector} from "react-redux";
import { BasketButton } from "@/components/responsive/product/basketBlock/basketButton/BasketButton";
import { PlaceholderBlock } from "@/components/responsive/product/placeholderBlock/PlaceholderBlock";
import { ShippingContextList } from "@/models/scope/shipping/ShippingContextList";
import { RootState } from "@/models/appState/RootState";
import { addToCartAction } from "@/redux/reducers/responsive/cart/cartActions";
import { fetchProductAvailabilities } from "@/redux/reducers/responsive/product/productAvailabilityActions";
import { AVAILABLE_PRODUCT_STATUS, CAN_BE_AVAILABLE_STATUS, LAYER_TYPE, PLACEHOLDER_TYPE, } from "@/utils/constants";
import Utils from "@/libs/Utils";

interface Props {
  crossedOutPrice?: number;
  price: number;
  productId: string;
  handleOpenLayer: (layerType: string, selectedProductId?: string) => void;
  trackingData: any;
}

export const PackBottom: VoidFunctionComponent<Props> = ({ crossedOutPrice, price, productId, handleOpenLayer, trackingData  }) => {
  const dispatch = useDispatch();
  const bundleSaleability = useSelector((state: RootState) => state.availability.bundleSaleability);
  const shopId: string = useSelector((state: RootState) => state.header.shopId || state.header.shop?.shopInfos?.id);
  useEffect(() => {
    if ((!shopId && bundleSaleability.length == 0) || (shopId && bundleSaleability.length > 0)) {
      dispatch(fetchProductAvailabilities(
        {
          allShops: false,
          productId,
        },
        ShippingContextList.BUNDLE_PRODUCT_SHEET,
      ))
    }
  }, [shopId]);

  const getSaleabilityForProduct = (productId: string) => {
    const productSaleabilityData = bundleSaleability.find(item => item.hasOwnProperty(productId));
    return productSaleabilityData ? productSaleabilityData[productId] : null;
  };
  const itemSaleabilityData = getSaleabilityForProduct(productId);
  const addToCartHandler = (): void => {
    if (itemSaleabilityData?.saleability === AVAILABLE_PRODUCT_STATUS) {
      dispatch(addToCartAction({
        productId,
        quantity: 1,
        callback: () => handleOpenLayer(LAYER_TYPE.BASKET), trackingData
      }));
    } else {
      handleOpenLayer(shopId ? LAYER_TYPE.STOCK_LOCATOR : LAYER_TYPE.ATTACHEMENT, productId);
    }
  }


  return <div className="bottom">
    {!!crossedOutPrice && (
      <p className="price crossed">{`${Utils.formatPriceWithoutTax(crossedOutPrice)} €`}</p>
    )}
    <p className="price">{`${Utils.formatPriceWithoutTax(price)}€`}</p>
    {  itemSaleabilityData?.pendingStatus == false ? (itemSaleabilityData?.saleability === AVAILABLE_PRODUCT_STATUS || itemSaleabilityData?.saleability === CAN_BE_AVAILABLE_STATUS) &&
      <BasketButton
        isBasketButtonEnable={itemSaleabilityData?.saleability === AVAILABLE_PRODUCT_STATUS}
        handleClick={addToCartHandler}
        isPositionFixed={false}
        optionNumbers={[1]}
        type="primary"
        bascketButtonClassName={"noPadding basket-btn"}
        isQuantityHidden={true} />: <PlaceholderBlock type={PLACEHOLDER_TYPE.BASKET_BUNDLE} />}
  </div>
}

